import React, { useState, useEffect } from 'react';

export const PILER_FACTS = [
  {
    icon: '📍',
    heading: 'భౌగోళిక కూడలి • The Equidistant Hub',
    te: 'రాయచోటి (55 కి.మీ), తిరుపతి (56 కి.మీ), చిత్తూరు (57 కి.మీ), మదనపల్లె (58 కి.మీ) — ఈ నాలుగు నగరాల సరిగ్గా నడిబొడ్డున మన పీలేరు ఉంది!',
    en: 'Piler sits at the exact geometric center of four major cities: Rayachoti (55 km), Tirupati (56 km), Chittoor (57 km) & Madanapalle (58 km)!',
  },
  {
    icon: '🌊',
    heading: 'పేరు వెనుక కథ • Etymology',
    te: "‘పిల్ల’ (చిన్న) మరియు ‘ఏరు’ (నది/వాగు) అనే అందమైన తెలుగు పదాల కలయిక నుంచే మన ‘పీలేరు’ అనే పేరు వచ్చింది!",
    en: 'The name "Pileru" translates directly to "small river stream" in Telugu, derived from Pilla (small) and Eru (stream)!',
  },
  {
    icon: '⛰️',
    heading: 'ఆహ్లాదకరమైన వాతావరణం • Elevation & Climate',
    te: 'సముద్ర మట్టానికి 458 మీటర్ల (1,502 అడుగులు) ఎత్తులో ఉండటం వల్ల, కోస్తా తీర ప్రాంతాలతో పోలిస్తే పీలేరు వాతావరణం ఎంతో ఆహ్లాదకరంగా ఉంటుంది!',
    en: 'At 458 meters (1,502 ft) above sea level, Piler enjoys a cooler, more temperate climate than coastal Andhra Pradesh!',
  },
];

export default function PilerTriviaCard() {
  const [index, setIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);
  const [progressKey, setProgressKey] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIsFading(true);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % PILER_FACTS.length);
        setIsFading(false);
        setProgressKey((k) => k + 1);
      }, 260);
    }, 8000);

    return () => clearInterval(timer);
  }, []);

  const fact = PILER_FACTS[index];

  return (
    <div className="piler-trivia-card" role="region" aria-label="Piler Trivia">
      {/* Top 8-second hairline progress line */}
      <div className="piler-trivia-progress-track">
        <div key={progressKey} className="piler-trivia-progress-bar" />
      </div>

      {/* Line 1: Main Hook */}
      <div className="piler-trivia-header">
        <div className="piler-trivia-main-hook">
          <span className="piler-trivia-bulb-icon" aria-hidden="true">💡</span>
          <span className="piler-trivia-hook-text">మీకు తెలుసా? • Did you know?</span>
        </div>
        <span className="piler-trivia-tag">PILER</span>
      </div>

      {/* Line 2: Card Topic Heading (UNDER LINE 1) */}
      <div className="piler-trivia-subhead">
        <span className="piler-trivia-icon" aria-hidden="true">{fact.icon}</span>
        <span className="piler-trivia-heading-text">{fact.heading}</span>
      </div>

      {/* Dynamic Content */}
      <div
        className="piler-trivia-content"
        style={{
          opacity: isFading ? 0 : 1,
          transform: isFading ? 'translateY(3px)' : 'translateY(0)',
          transition: 'opacity 0.26s ease-out, transform 0.26s ease-out',
        }}
      >
        <p className="piler-trivia-te">{fact.te}</p>
        <div className="piler-trivia-divider" />
        <p className="piler-trivia-en">{fact.en}</p>
      </div>
    </div>
  );
}
